import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ObservableDocumentLogSchema = withDefaults({
  type: 'observable-document-log',
  fields: [
    {
      kind: 'attribute',
      name: 'detail',
    },
    {
      kind: 'attribute',
      name: 'logSource',
    },
    {
      kind: 'belongsTo',
      name: 'observableDocument',
      type: 'observable-document',
      options: {
        async: false,
        inverse: 'observableDocumentLogs',
      },
    },
  ],
});

export default ObservableDocumentLogSchema;
